module.exports = __webpack_public_path__ + "media/images/apple-icon-76x76-6086c05d.png";